export default "__VITE_ASSET__0BLAp$i0__"